// Imports
import { Route } from 'react-router-dom';
import Websites from '.';
import AdoptWebsite from './adopt';
import ChangeSubscription from './change-subscription';
import CreateWebsite from './create';


// Function component
const sectionRoutes = (
	<Route path='websites'>
		<Route index element={<Websites />} />
		<Route path='create' element={<CreateWebsite />} />
		<Route path='adopt' element={<AdoptWebsite />} />
		<Route path=':websiteID/change-subscription' element={<ChangeSubscription />} />
	</Route>
);

export default sectionRoutes;
